/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { J5RegistryV1ArtifactCommandServiceArtifactDownloadArtifactDownloadRequest } from '@interxfi/types';

export async function j5RegistryV1ArtifactCommandServiceArtifactDownload(baseUrl: string | undefined, request?: J5RegistryV1ArtifactCommandServiceArtifactDownloadArtifactDownloadRequest, requestInit?: RequestInit): Promise<undefined> { return makeRequest<undefined, J5RegistryV1ArtifactCommandServiceArtifactDownloadArtifactDownloadRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/registry/v1/artifact/c/download/:owner/:bundle/:version/:name', request, requestInit)); }

